import { render, staticRenderFns } from "./CodifierStat.vue?vue&type=template&id=3106b210&scoped=true&"
import script from "./CodifierStat.vue?vue&type=script&lang=js&"
export * from "./CodifierStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106b210",
  null
  
)

export default component.exports